module.exports = __webpack_public_path__ + "img/plus_light.6d042ade.svg";